<template>
  <span
    class="whitespace-nowrap text-start font-semibold text-gray-900"
    :class="[small ? 'text-xs' : 'text-sm']"
  >
    <slot>
      {{ title }}
    </slot>
  </span>
</template>

<script setup lang="ts">
type Props = {
  title?: string;
  small?: boolean;
};

const { small = false } = defineProps<Props>();
</script>
